import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import GoogleMapReact from "google-map-react";
import NVD3Chart from "react-nvd3";
import d3 from "d3";
import {
  Panel,
  PanelHeader,
  PanelBody,
} from "../../components/panel/panel.jsx";
import DateRangePicker from "react-bootstrap-daterangepicker";
import Moment from "moment";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Pie } from "react-chartjs-2";
import Config from "../../Config.js";
import LoaderSpinner from "../../components/Loaderspinner/LoaderSpinner";

import { CSVLink } from "react-csv";
import { countryList } from "../../components/Conteries";
import { getProductTimeWiseScanningAnalyticReport } from "../../api/reportApi";

import { ProductionTimeWiseAnalysis } from '../../components/Modal/modal';
import { ProductionCountrywisescans } from '../../components/Modal/modal';
import { Bestperformingvendors } from '../../components/Modal/modal';
import { ProductionLocationscitywisescans } from '../../components/DataTable/datatable.js';
import { ProductionBestperformingVendordetail } from '../../components/DataTable/datatable.js';


import {
  countrycsvheaders,
  Citycsvheaders,
  Categorycsvheaders,
  Subcategorycsvheaders,
  Lablecsvheaders,
  Vendorheaders,
} from "./CsvHeaders/CsvHeaders";

const Productreports = (props) => {
  let history = useHistory();
  const { Productlist } = props;
  const { ProductID } = props;
  // console.log("Articlelist==>", ProductID)
  const [modalCountry, setmodalCountry] = useState(false);
  const [modalCity, setmodalCity] = useState(false);
  const [modalVendors, setmodalVendors] = useState(false);
  const [bestScanVendorisall, setbestScanVendorisall] = useState(false);
  const [ArticleAttributeList, setArticleAttributeList] = useState([]);
  const [graphData, setgraphData] = useState(null);
  const [selectStartDate, setselectStartDate] = useState(
    Moment(new Date()).subtract("days", 30)
  );
  const [selectEndDate, setselectEndDate] = useState(Moment(new Date()));
  const [Isloading, setIsloading] = useState(false);
  const [articleID, setarticleID] = useState("");
  const [ArticleAttributeID, setArticleAttributeID] = useState("");
  const [bestscancountry, setbestscancountryisall] = useState(false);

  const [Locationswisecanning, setLocationswisecanning] = useState([]);
  const [LocationsCitywisecanning, setLocationsCitywisecanning] = useState([]);

  const [bDownloadReady, setDownloadReady] = useState(false);
  const [countrycsvdata, setcountrycsvdata] = useState([]);

  const [cityDownloadReady, setcityDownloadReady] = useState(false);
  const [Citycsvdata, setCitycsvdata] = useState([]);

  const [DatatableVendordetailsWiseList, setDatatableVendordetailsWiseList] =
    useState([]);
  const [DatatableVendorWiseList, setDatatableVendorWiseList] = useState([]);
  const [VendorDownloadReady, setVendorDownloadReady] = useState(false);
  const [Vendorcsvdata, setVendorcsvdata] = useState([]);
  const [VendorDetailsAllshow, setVendorDetailsAllshow] = useState(false);
  const [DatatablecountryWiseScanLits, setDatatablecountryWiseScanLits] =
    useState([]);
  const [bestscancountryishow, setbestscancountryishow] = useState(false);
  const [articleTimeWiseScanListDetalis, setarticleTimeWiseScanListDetalis] =
    useState([]);
  const [IstimewisemodalOpen, setIstimewisemodalOpen] = useState(false);
  const [bestsCityallshow, setbestsCityallshow] = useState(false);
  const countrycsvRef = useRef(null);
  const CitycsvRef = useRef(null);
  const VendorcsvRef = useRef(null);

  useEffect(async () => {
    let checkLogin = localStorage.getItem("loginUserID");
    if (
      checkLogin === "" ||
      checkLogin === null ||
      checkLogin === "null" ||
      checkLogin === undefined
    ) {
      history.push("/Login");
    } else {
      // LoadGraph(selectStartDate, selectEndDate, "", "")
      if (ProductID !== null && ProductID !== undefined && ProductID !== "") {
        localStorage.setItem("localProductIDAttribute", "");
        localStorage.setItem("localProductID", ProductID);
        GetAllArticleAttribute(ProductID);
      } else {
        localStorage.setItem("localProductIDAttribute", "");
        localStorage.setItem("localProductID", "");
        LoadGraph(selectStartDate, selectEndDate, "", "");
      }
    }
  }, []);
  // useEffect(() => {
  //   if (ProductID !== null && ProductID !== undefined && ProductID !== "") {
  //     GetAllArticleAttribute(ProductID)
  //   }
  // }, [])

  const LoadGraph = async (stardate, enddate, articleid, attributeid) => {
    setIsloading(true);
    document.body.style.overflow = "hidden";
    let loginid = localStorage.getItem("loginUserID");
    let Auth0token = localStorage.getItem("Auth0token");
    let subUserIDList = localStorage.getItem("subUserIDList");
    let GraphstartDate = Moment(stardate).format("YYYY/MM/DD") + " 00:00:00";
    let GraphEndDate = Moment(enddate).format("YYYY/MM/DD") + " 00:00:00";
    fetch(
      Config.apiUrl +
      "QRCodeScanHistory/ProductScanningAnalyticReport?StartDate=" +
      GraphstartDate +
      "&EndDate=" +
      GraphEndDate +
      "&PageCount=10000" +
      "&ProductId=" +
      articleid +
      "&ProductVariantId=" +
      attributeid,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          userCompanyID: loginid,
          subUserCompanyID: subUserIDList,
          Authorization: "Bearer " + Auth0token,
        },
      }
    )
      .then((response) => {
        if (response.ok) {
          return response.json();
        }
        throw new Error("Something went wrong");
      })
      .then(async (responseJson) => {
        setIsloading(false);
        document.body.style.overflow = "auto";
        console.log("responseJson Grap", responseJson);
        let bestPerformVendorWiseListTemp =
          responseJson?.productPerformVendorWiseList;
        if (bestPerformVendorWiseListTemp) {
          await bestPerformVendorWiseListTemp.forEach((item, index) => {
            item.sr = index + 1;
          });
          setDatatableVendorWiseList(bestPerformVendorWiseListTemp);
        } else {
          setDatatableVendorWiseList([]);
        }
        setgraphData(responseJson);
        let responseJsonTemp = responseJson?.productCountryWiseScanList;
        if (responseJsonTemp) {
          responseJsonTemp.forEach((item, index) => {
            item.sr = index + 1;
          });
          setDatatablecountryWiseScanLits(
            responseJsonTemp.filter((x) => x.name !== "country13")
          );
        } else {
          setDatatablecountryWiseScanLits([]);
        }
      })
      .catch((error) => {
        setIsloading(false);
        document.body.style.overflow = "auto";
        console.log(error);
        setgraphData(null);
      });
  };
  const GetAllArticleAttribute = async (ArticleID) => {
    console.log("ArticleID==>", ArticleID);
    try {
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      setarticleID(ArticleID);
      let EmaptyArrry = [];
      setArticleAttributeList(EmaptyArrry);
      setArticleAttributeID("");
      if (ArticleID !== null && ArticleID !== "" && ArticleID !== undefined) {
        localStorage.setItem("localProductIDAttribute", "");
        localStorage.setItem("localProductID", ArticleID);
        LoadGraph(selectStartDate, selectEndDate, ArticleID, "");
        await fetch(
          Config.apiUrl + "AttributeValueMap?articleProductID=" + ArticleID,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              userCompanyID: loginid,
              Authorization: "Bearer " + Auth0token,
            },
          }
        ).then((resp1) => {
          resp1.json().then((result) => {
            setArticleAttributeList(result);
          });
        });
      } else {
        localStorage.setItem("localProductIDAttribute", "");
        localStorage.setItem("localProductID", "");
        LoadGraph(selectStartDate, selectEndDate, "", "");
        setArticleAttributeList(EmaptyArrry);
      }
    } catch (error) {
      let EmaptyArrry = [];
      setArticleAttributeList(EmaptyArrry);
      alert(error);
    }
  };
  const selectArticleAttribute = (AttributeID) => {
    localStorage.setItem("localProductIDAttribute", AttributeID);
    LoadGraph(selectStartDate, selectEndDate, articleID, AttributeID);
    setArticleAttributeID(AttributeID);
  };

  const toggleCountry = (item) => {
    console.log("item", item)
    getCountrywisescanningDetail(item);
  };
  const getCountrywisescanningDetail = (CountryName) => {
    if (
      CountryName?.name !== null &&
      CountryName?.name !== undefined &&
      CountryName?.name !== ""
    ) {
      let GraphstartDate =
        Moment(selectStartDate).format("YYYY/MM/DD") + " 00:00:00";
      let GraphEndDate =
        Moment(selectEndDate).format("YYYY/MM/DD") + " 00:00:00";
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      setIsloading(true);
      document.body.style.overflow = "hidden";

      let myProductID = localStorage.getItem("localProductID");
      let localProductIDAttribute = localStorage.getItem(
        "localProductIDAttribute"
      );
      if (!localProductIDAttribute) {
        localProductIDAttribute = "";
      }
      if (!myProductID) {
        myProductID = "";
      }

      fetch(
        Config.apiUrl +
        "QRCodeScanHistory/ProductLocationsCountryWiseReportScansDetails?StartDate=" +
        GraphstartDate +
        "&EndDate=" +
        GraphEndDate +
        "&CountryName=" +
        CountryName?.name +
        "&PageCount=10000" +
        "&ProductId=" +
        myProductID +
        "&ProductVariantId=" +
        localProductIDAttribute,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          setmodalCountry(true);
          setLocationswisecanning(responseJson);
          setIsloading(false);
          document.body.style.overflow = "auto";
        })
        .catch((error) => {
          setmodalCountry(false);
          document.body.style.overflow = "auto";
          console.log(error);
          setLocationswisecanning([]);
        });
    } else {
      setmodalCountry(false);
      setLocationswisecanning([]);
      console.log("Country Name Not Found");
    }
  };

  const toggleCity = (item) => {
    // getcitywisescanningDetail(item);
    setmodalCity(!modalCity);
  };

  const getcitywisescanningDetail = (CountryName) => {
    if (
      CountryName?.countryName !== null &&
      CountryName?.countryName !== undefined &&
      CountryName?.countryName !== ""
      // &&
      // CountryName?.cityName !== null &&
      // CountryName?.cityName !== undefined &&
      // CountryName?.cityName !== ""
    ) {
      var cityname = "";
      if (
        CountryName?.cityName !== null &&
        CountryName?.cityName !== "null" &&
        CountryName?.cityName !== undefined &&
        CountryName?.cityName !== ""
      ) {
        cityname = CountryName?.cityName;
      }
      let GraphstartDate =
        Moment(selectStartDate).format("YYYY/MM/DD") + " 00:00:00";
      let GraphEndDate =
        Moment(selectEndDate).format("YYYY/MM/DD") + " 00:00:00";
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      setIsloading(true);
      document.body.style.overflow = "hidden";

      let myProductID = localStorage.getItem("localProductID");
      let localProductIDAttribute = localStorage.getItem(
        "localProductIDAttribute"
      );
      if (!localProductIDAttribute) {
        localProductIDAttribute = "";
      }
      if (!myProductID) {
        myProductID = "";
      }

      fetch(
        Config.apiUrl +
        "QRCodeScanHistory/ProductLocationsCityWiseReportScansDetails?StartDate=" +
        GraphstartDate +
        "&EndDate=" +
        GraphEndDate +
        "&CountryName=" +
        CountryName?.countryName +
        "&cityName=" +
        cityname +
        "&PageCount=10000" +
        "&ProductId=" +
        myProductID +
        "&ProductVariantId=" +
        localProductIDAttribute,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          console.log("Produ8ctionCountryWiseCity=>", responseJson);
          setmodalCity(true);
          // setLocationsCitywisecanning(responseJson);
          let responseJsonTemp = responseJson;
          if (responseJsonTemp) {
            responseJsonTemp.forEach((item, index) => {
              item.sr = index + 1;
            });
            setLocationsCitywisecanning(responseJsonTemp);
          } else {
            setLocationsCitywisecanning([]);
          }
          setIsloading(false);
          document.body.style.overflow = "auto";
        })
        .catch((error) => {
          setmodalCity(false);
          document.body.style.overflow = "auto";
          console.log(error);
          setLocationsCitywisecanning([]);
        });
    } else {
      setmodalCity(false);
      setLocationsCitywisecanning([]);
      console.log("Country  Name && City Name Not Found");
    }
  };
  const togglecountryTableclosed = () => {
    setbestscancountryishow(false);
  };

  const startDate = Moment().subtract(7, "days");
  const endDate = Moment();
  var convertNumberWithCommas = function (x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const dateRange = {
    // currentWeek:
    //   Moment().subtract("days", 7).format("D MMMM YYYY") +
    //   " - " +
    //   Moment().format("D MMMM YYYY"),
    // prevWeek:
    //   Moment().subtract("days", 15).format("D MMMM") +
    //   " - " +
    //   Moment().subtract("days", 8).format("D MMMM YYYY"),

    currentWeek:
      Moment(selectStartDate).format("DD / MM / YYYY") +
      " - " +
      Moment(selectEndDate).format("DD / MM / YYYY"),

    prevWeek:
      Moment(selectStartDate).format("D / MM / YYYY") +
      " - " +
      Moment(selectEndDate).format("D / MM / YYYY"),
  };

  const getDate = (minusDate) => {
    var d = new Date();
    d = d.setDate(d.getDate() - minusDate);
    return d;
  };
  const handleDateApplyEvent = (event, picker) => {
    var startDate = picker.startDate;
    var endDate = picker.endDate;
    var gap = endDate.diff(startDate, "days");

    var currentWeek =
      startDate.format("D MMMM YYYY") + " - " + endDate.format("D MMMM YYYY");
    var prevWeek =
      Moment(startDate).subtract("days", gap).format("D MMMM") +
      " - " +
      Moment(startDate).subtract("days", 1).format("D MMMM YYYY");

    setselectEndDate(new Date(picker.endDate));
    setselectStartDate(new Date(picker.startDate));
    LoadGraph(picker.startDate, picker.endDate, articleID, ArticleAttributeID);
  };

  const areaChartOptions = {
    pointSize: 0.5,
    useInteractiveGuideline: true,
    durection: 300,
    showControls: false,
    controlLabels: {
      stacked: "Stacked",
    },
    yAxis: {
      tickFormat: d3.format(",.0f"),
    },
    xAxis: {
      tickFormat: function (d) {
        var monthsName = [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ];
        d = new Date(parseInt(d));
        d = monthsName[d.getMonth()] + " " + d.getDate();
        return d;
      },
    },
  };
  const map = {
    center: {
      lat: 59.95,
      lng: 30.33,
    },
    zoom: 9,
  };
  const date = new Date();
  const formatDate = (d) => {
    console.log(d);
    var monthsName = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    d = new Date(parseInt(d));
    d = monthsName[d.getMonth()] + " " + d.getDate();
    return d;
  };
  const pieChart = {
    data: {
      labels: ["Android", "ISO"],
      datasets: [
        {
          data: [300, 160],
          height: [10],
          width: [10],
          backgroundColor: ["#5B8FF9", "#61DDAA"],
          borderColor: ["#5B8FF9", "#61DDAA"],
          borderWidth: 2,
          label: "My dataset",
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
    },
  };

  useEffect(() => {
    if (countrycsvRef && countrycsvRef.current && bDownloadReady) {
      countrycsvRef.current.link.click();
      setDownloadReady(false);
    }
  }, [bDownloadReady]);

  const handleActioncountry = (actionType) => {
    if (actionType === "DOWNLOAD") {
      if (Locationswisecanning.length > 0) {
        let withheder = [];
        let csvdata = [...Locationswisecanning];
        for (let index = 0; index < csvdata.length; index++) {
          let element = csvdata[index];
          let tempdata = {
            sr: index + 1,
            cityName: element.cityName ? element.cityName : "N/A",
            totalScanCount: element.totalScanCount,
            countryName: element.countryName ? element.countryName : "N/A",
          };
          withheder.push(tempdata);
        }
        setcountrycsvdata(withheder);
        setDownloadReady(true);
      }
    }
  };

  useEffect(() => {
    if (CitycsvRef && CitycsvRef.current && cityDownloadReady) {
      CitycsvRef.current.link.click();
      setcityDownloadReady(false);
    }
  }, [cityDownloadReady]);
  const handleActionCity = (actionType) => {
    if (actionType === "DOWNLOAD") {
      if (LocationsCitywisecanning.length > 0) {
        let withheder = [];
        let csvdata = [...LocationsCitywisecanning];
        for (let index = 0; index < csvdata.length; index++) {
          let element = csvdata[index];
          let Fileimagepath = "";
          if (element.productImagepath) {
            Fileimagepath = Config.contentUrl + element.productImagepath;
          }
          let tempdata = {
            sr: index + 1,
            cityName: element.cityName ? element.cityName : "N/A",
            totalScanCount: element.totalScanCount,
            countryName: element.countryName ? element.countryName : "N/A",
            itemName: element.productName ? element.productName : "N/A",
            image: element.productImagepath ? Fileimagepath : "N/A",
          };
          withheder.push(tempdata);
        }
        setCitycsvdata(withheder);
        setcityDownloadReady(true);
      }
    }
  };
  const toggleVendors = () => {
    setmodalVendors(!modalVendors);
  };
  const toggleVendorsshowall = () => {
    setbestScanVendorisall(!bestScanVendorisall);
  };

  const getVendorwisescanningDetail = (Vendor) => {
    if (
      Vendor?.vendorID !== null &&
      Vendor?.vendorID !== undefined &&
      Vendor?.vendorID !== ""
    ) {
      let GraphstartDate =
        Moment(selectStartDate).format("YYYY/MM/DD") + " 00:00:00";
      let GraphEndDate =
        Moment(selectEndDate).format("YYYY/MM/DD") + " 00:00:00";
      let loginid = localStorage.getItem("loginUserID");
      let Auth0token = localStorage.getItem("Auth0token");
      setIsloading(true);
      document.body.style.overflow = "hidden";

      let myProductID = localStorage.getItem("localProductID");
      let localProductIDAttribute = localStorage.getItem(
        "localProductIDAttribute"
      );
      if (!localProductIDAttribute) {
        localProductIDAttribute = "";
      }
      if (!myProductID) {
        myProductID = "";
      }

      fetch(
        Config.apiUrl +
        "QRCodeScanHistory/ProductVendorReportScansDetails?StartDate=" +
        GraphstartDate +
        "&EndDate=" +
        GraphEndDate +
        "&VendorID=" +
        Vendor?.vendorID +
        "&PageCount=10000" +
        "&ProductId=" +
        myProductID +
        "&ProductVariantId=" +
        localProductIDAttribute,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            subUserCompanyID: [],
            userCompanyID: loginid,
            Authorization: "Bearer " + Auth0token,
          },
        }
      )
        .then((response) => {
          if (response.ok) {
            return response.json();
          }
          throw new Error("Something went wrong");
        })
        .then((responseJson) => {
          setmodalVendors(true);
          let responseJsonTemp = responseJson;
          if (responseJsonTemp) {
            responseJsonTemp.forEach((item, index) => {
              item.sr = index + 1;
            });
            setDatatableVendordetailsWiseList(responseJsonTemp);
          } else {
            setDatatableVendordetailsWiseList([]);
          }
          setIsloading(false);
          document.body.style.overflow = "auto";
        })
        .catch((error) => {
          setmodalVendors(false);
          setIsloading(false);
          document.body.style.overflow = "auto";
          console.log(error);
          setDatatableVendordetailsWiseList([]);
        });
    } else {
      setmodalVendors(false);
      setIsloading(false);
      setLocationsCitywisecanning([]);
      console.log("Country  Name && City Name Not Found");
    }
  };
  useEffect(() => {
    if (VendorcsvRef && VendorcsvRef.current && VendorDownloadReady) {
      VendorcsvRef.current.link.click();
      setVendorDownloadReady(false);
    }
  }, [VendorDownloadReady]);
  const handleActionVendor = (actionType) => {
    if (actionType === "DOWNLOAD") {
      if (DatatableVendordetailsWiseList.length > 0) {
        let withheder = [];
        let csvdata = [...DatatableVendordetailsWiseList];
        for (let index = 0; index < csvdata.length; index++) {
          let element = csvdata[index];
          let Fileimagepath = "";
          if (element.vendorLogo) {
            Fileimagepath = Config.contentUrl + element.vendorLogo;
          }
          let FileimagepathProduct = "";
          if (element.productImagepath) {
            FileimagepathProduct = Config.contentUrl + element.productImagepath;
          }
          let tempdata = {
            sr: index + 1,
            vendorName: element.vendorName ? element.vendorName : "N/A",
            vendorLogo: element.vendorLogo ? Fileimagepath : "N/A",
            productName: element.productName ? element.productName : "N/A",
            productImagepath: element.productImagepath
              ? FileimagepathProduct
              : "N/A",
            totalScanCount: element.totalScanCount,
          };
          withheder.push(tempdata);
        }
        setVendorcsvdata(withheder);
        setVendorDownloadReady(true);
      }
    }
  };
  const ToggleTimewisemodalOpen = () => {
    setIstimewisemodalOpen(!IstimewisemodalOpen);
  };
  const GetProductTimeWiseScanningAnalyticReport = async () => {
    let StartDate = Moment(selectStartDate).format("YYYY/MM/DD") + " 00:00:00";
    let EndDate = Moment(selectEndDate).format("YYYY/MM/DD") + " 00:00:00";
    let data = await getProductTimeWiseScanningAnalyticReport(
      StartDate,
      EndDate,
      articleID,
      ArticleAttributeID,
      10000
    );
    ToggleTimewisemodalOpen();
    setarticleTimeWiseScanListDetalis(data);
  };
  const columnsTimewise = React.useMemo(
    () => [
      {
        name: "Sr #",
        width: "9%",
        accessor: "sr",
        selector: (row) => `${row.sr}`,
        sortable: false,
        cell: (row, index) => row.sr,
      },
      {
        name: "Product name",
        accessor: "sr",
        selector: (row) => `${row?.productName}`,
        sortable: false,
        cell: (row, index) => row?.productName,
      },
      {
        name: "Image",
        accessor: "Image",
        selector: "Image",
        sortable: false,
        headerStyle: { textAlign: "right" },
        headerClassName: "rt-tr-align-left",
        cell: (row) => {
          {
            return (
              <div className="widget-list-media icon">
                <img
                  src={Config?.contentUrl + row?.imagePath}
                  onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src = "../assets/img/noimage.jpg";
                  }}
                  // src="../assets/img/user/user-7.jpg"
                  style={{ height: "50px" }}
                ></img>
              </div>
            );
          }
        },
      },
      {
        name: "Total Scans",
        accessor: "totalScans",
        selector: (row) => `${row.totalScanCount}`,
        sortable: true,
        headerClassName: "rt-tr-align-right",
      },
    ],
    []
  );

  return (
    <div>
      <LoaderSpinner isrefresh={Isloading} />
      <h1 className="page-header mb-3">Production scanning analytics</h1>
      <div className="d-sm-flex align-items-center mb-3">
        <DateRangePicker
          startDate={selectStartDate}
          endDate={selectEndDate}
          onApply={handleDateApplyEvent}
          dateFormat="DD/MM/YYYY"
        >
          <button className="btn btn-inverse mr-2 text-truncate">
            <i className="fa fa-calendar fa-fw text-white-transparent-5 ml-n1"></i>
            <span>{dateRange.currentWeek}</span>
            <b className="caret"></b>
          </button>
        </DateRangePicker>
        {/*<button type="button" className="btn btn-primary mr-2">GO</button>*/}
      </div>
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <div className="card border-0 bg-dark text-white mb-3 overflow-hidden">
            <div className="card-body">
              <div
                className=" p-15"
                style={{ borderWidth: "1px", borderStyle: "dashed" }}
              >
                <form action="" method="POST">
                  <div className="row align-items-center">
                    <div className="form-group col-xl-9 col-lg-10 col-md-12  row align-items-center mb-0">
                      <label className="col-form-label col-lg-5  col-md-12">
                        Select Product
                      </label>
                      <div className="col-lg-7 col-md-8">
                        <select
                          value={articleID}
                          class="default-select2 form-control"
                          onChange={(e) => {
                            GetAllArticleAttribute(e.target.value);
                          }}
                        >
                          <option value={""}> --- Select Product --- </option>
                          {Productlist !== undefined && Productlist !== null ? (
                            Productlist?.map((item, i) => (
                              <option value={item?._id}>
                                {item?.articleName ? item?.articleName : "N/A"}
                              </option>
                            ))
                          ) : (
                            <></>
                          )}
                        </select>
                      </div>
                    </div>

                    <div className="col-xl-2 col-lg-2 col-md-12 mt-2 mt-lg-0 d-flex justify-content-start pl-2 pl-lg-0 px-4">
                      {/* <Link
                        to="/qrcodemanagement/product-qrcode"
                        className="btn  btn-purple"
                      >
                        Product list
                      </Link> */}
                      <Link
                        to="/product-qrcode"
                        className="btn  btn-purple"
                      >
                        Product list
                      </Link>
                    </div>
                  </div>
                  <div className="row align-items-center  mt-2">
                    <div className="form-group col-xl-9 col-lg-10 col-md-12  row align-items-center mb-0">
                      <label className="col-form-label col-lg-5  col-md-12">
                        Selection variant combination
                      </label>
                      <div className="col-lg-7 col-md-8">
                        <select
                          class="default-select2 form-control mr-2"
                          onChange={(e) => {
                            selectArticleAttribute(e.target.value);
                          }}
                        >
                          <option value={""}>
                            {" "}
                            --- Select Combination ---{" "}
                          </option>
                          {ArticleAttributeList !== undefined &&
                            ArticleAttributeList !== null ? (
                            ArticleAttributeList?.map((item, i) =>
                              item.attributeValue1 != "" &&
                                item.attributeValue2 != "" &&
                                item.attributeValue3 != "" &&
                                item.attributeValue4 != "" &&
                                item.attributeValue5 != "" ? (
                                <option value={item?._id}>
                                  {item.attributeValue1 +
                                    " / " +
                                    item.attributeValue2 +
                                    " / " +
                                    item.attributeValue3 +
                                    " / " +
                                    item.attributeValue4 +
                                    " / " +
                                    item.attributeValue5}
                                </option>
                              ) : item.attributeValue1 != "" &&
                                item.attributeValue2 != "" &&
                                item.attributeValue3 != "" &&
                                item.attributeValue4 != "" &&
                                item.attributeValue5 === "" ? (
                                <option value={item?._id}>
                                  {item.attributeValue1 +
                                    " / " +
                                    item.attributeValue2 +
                                    " / " +
                                    item.attributeValue3 +
                                    " / " +
                                    item.attributeValue4}
                                </option>
                              ) : item.attributeValue1 != "" &&
                                item.attributeValue2 != "" &&
                                item.attributeValue3 != "" &&
                                item.attributeValue4 === "" &&
                                item.attributeValue5 === "" ? (
                                <option value={item?._id}>
                                  {item.attributeValue1 +
                                    " / " +
                                    item.attributeValue2 +
                                    " / " +
                                    item.attributeValue3}
                                </option>
                              ) : item.attributeValue1 != "" &&
                                item.attributeValue2 != "" &&
                                item.attributeValue3 === "" &&
                                item.attributeValue4 === "" &&
                                item.attributeValue5 === "" ? (
                                <option value={item?._id}>
                                  {item.attributeValue1 +
                                    " / " +
                                    item.attributeValue2}
                                </option>
                              ) : item.attributeValue1 != "" &&
                                item.attributeValue2 === "" &&
                                item.attributeValue3 === "" &&
                                item.attributeValue4 === "" &&
                                item.attributeValue5 === "" ? (
                                <option value={item?._id}>
                                  {item.attributeValue1}
                                </option>
                              ) : (
                                <></>
                              )
                            )
                          ) : (
                            <></>
                          )}
                        </select>
                      </div>
                    </div>

                    {/* <div className="col-lg-3 col-md-12 mt-2 mt-lg-0 d-flex justify-content-startpl-2 pl-lg-0 px-4">
                      <button className="btn  btn-primary mr-3">GO</button>
                    </div> */}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <div className="card border-0 bg-dark text-white mb-3 overflow-hidden">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12 d-flex justify-content-center">
                  <div className="table-responsive">
                    <table
                      className="table table-bordered m-b-0"
                      style={{ color: "#FFFFFF" }}
                    >
                      <thead style={{ backgroundColor: "#959595" }}>
                        <tr className="text-center">
                          <th>Product Name</th>
                          <th>Category</th>
                          <th>Variant combination</th>
                          <th>Image</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="text-center">
                          <td className="align-middle">
                            {graphData !== null &&
                              graphData?.productName !== null &&
                              graphData?.productName !== ""
                              ? graphData?.productName
                              : "N/A"}
                          </td>
                          <td className="align-middle">
                            {graphData !== null &&
                              graphData?.categoryName !== null &&
                              graphData?.categoryName !== ""
                              ? graphData?.categoryName +
                              "/" +
                              graphData?.subCategoryName
                              : "N/A"}
                          </td>
                          <td className="align-middle">
                            <div className="d-flex flex-wrap">
                              {graphData !== null &&
                                graphData?.productVariantCombinationList?.length >
                                0 ? (
                                graphData?.productVariantCombinationList?.map(
                                  (item, i) => (
                                    <div className="avariantCombinationitem">
                                      {item.attributeValue1 != "" &&
                                        item.attributeValue2 != "" &&
                                        item.attributeValue3 != "" &&
                                        item.attributeValue4 != "" &&
                                        item.attributeValue5 != "" ? (
                                        <div className="align-middle">
                                          {item.attributeValue1 +
                                            " / " +
                                            item.attributeValue2 +
                                            " / " +
                                            item.attributeValue3 +
                                            " / " +
                                            item.attributeValue4 +
                                            " / " +
                                            item.attributeValue5}
                                        </div>
                                      ) : item.attributeValue1 != "" &&
                                        item.attributeValue2 != "" &&
                                        item.attributeValue3 != "" &&
                                        item.attributeValue4 != "" &&
                                        item.attributeValue5 === "" ? (
                                        <div className="align-middle">
                                          {item.attributeValue1 +
                                            " / " +
                                            item.attributeValue2 +
                                            " / " +
                                            item.attributeValue3 +
                                            " / " +
                                            item.attributeValue4}
                                        </div>
                                      ) : item.attributeValue1 != "" &&
                                        item.attributeValue2 != "" &&
                                        item.attributeValue3 != "" &&
                                        item.attributeValue4 === "" &&
                                        item.attributeValue5 === "" ? (
                                        <div className="align-middle">
                                          {item.attributeValue1 +
                                            " / " +
                                            item.attributeValue2 +
                                            " / " +
                                            item.attributeValue3}
                                        </div>
                                      ) : item.attributeValue1 != "" &&
                                        item.attributeValue2 != "" &&
                                        item.attributeValue3 === "" &&
                                        item.attributeValue4 === "" &&
                                        item.attributeValue5 === "" ? (
                                        <div className="align-middle">
                                          {item.attributeValue1 +
                                            " / " +
                                            item.attributeValue2}
                                        </div>
                                      ) : item.attributeValue1 != "" &&
                                        item.attributeValue2 === "" &&
                                        item.attributeValue3 === "" &&
                                        item.attributeValue4 === "" &&
                                        item.attributeValue5 === "" ? (
                                        <div className="align-middle">
                                          {item.attributeValue1}
                                        </div>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  )
                                )
                              ) : (
                                <div className="avariantCombinationitem">
                                  N/A
                                </div>
                              )}
                            </div>
                          </td>

                          <td className="align-middle">
                            {/* <img
                            src="../assets/img/user/user-6.jpg"
                            alt=""
                            style={{ height: "50px" }}
                          ></img> */}
                            {graphData?.articleImageUrl !== null &&
                              graphData?.articleImageUrl !== "" &&
                              graphData?.articleImageUrl !== "" ? (
                              <img
                                src={
                                  Config?.contentUrl +
                                  graphData?.articleImageUrl
                                }
                                onError={({ currentTarget }) => {
                                  currentTarget.onerror = null; // prevents looping
                                  currentTarget.src =
                                    "../assets/img/noimage.jpg";
                                }}
                                // src="../assets/img/user/user-7.jpg"
                                style={{ height: "50px" }}
                              ></img>
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-xl-6">
          <div className="card border-0 bg-dark text-white mb-3 overflow-hidden">
            <div className="card-body p-0">
              <div className="row">
                <div className="col-xl-6 col-lg-8 col-xs-6">
                  <div style={{ padding: '15px' }}>
                    <div className="mb-3 text-grey">
                      <b className="mb-3 text-uppercase">TOTAL SCANS</b>
                    </div>
                    <div className="d-flex mb-1">
                      <h1 className="text-white mb-0 main-bold-text">
                        {graphData !== null && graphData?.totalScanCount !== null
                          ? graphData?.totalScanCount
                          : "0"}
                      </h1>
                    </div>
                  </div>
                </div>
                <div className="col-xl-6 col-lg-4 col-xs-6  align-items-center d-flex justify-content-end">
                  <img
                    src="../assets/img/theme/dashboard2.png"
                    alt=""
                    // height="150px"
                    // className=" d-none d-lg-block "
                    className="images-change"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-xl-6">
          <div className="card border-0 bg-dark text-white text-truncate mb-3">
            <div className="card-body p-0">
              <div className="row">
                <div className="col-xl-6 col-lg-8 col-xs-6">
                  <div style={{ padding: '15px' }}>
                    <div className="mb-3 text-grey">
                      <b className="mb-3 text-uppercase">
                        Saved to stt smart wallet
                      </b>
                    </div>
                    <div className="d-flex mb-1">
                      <h1 className="text-white mb-0 main-bold-text">
                        {graphData !== null &&
                          graphData?.totalSTTWalletSavedCount !== null
                          ? graphData?.totalSTTWalletSavedCount
                          : "0"}
                      </h1>
                    </div>
                    <div className="d-flex align-items-center mb-1 mt-4">
                      <h1 className="text-white mb-0">
                        {graphData !== null &&
                          graphData?.totalSTTWalletSavedPercent !== null
                          ? graphData?.totalSTTWalletSavedPercent
                          : "0"}
                        %
                      </h1>
                    </div>
                  </div>
                </div>

                <div className="col-xl-6 col-lg-4  col-xs-6 align-items-center d-flex justify-content-end">
                  <img
                    src="../assets/img/theme/dashboard1.png"
                    alt=""
                    className="images-change"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row change-header-bg">
        <div className="col-xl-8 col-lg-6 pb-4">
          <Panel className="penal-stretch">
            <PanelHeader className="bg-dark-blue">
              <h4 className="mb-0 text-grey">Time wise Analysis</h4>
            </PanelHeader>
            <PanelBody className="bg-dark-blue">
              <div className="mb-1">
                <h1 className="text-white mb-0">
                  {graphData !== null && graphData?.totalScanCount !== null
                    ? graphData?.totalScanCount
                    : "0"}
                </h1>
              </div>
              <div className="text-grey">
                <b className="mb-3">TOTAL SCANS</b>
              </div>
              <div style={{ height: "291px" }}>
                <div
                  className="widget-chart-full-width nvd3-inverse-mode"
                  style={{ height: "300px" }}
                >
                  {graphData !== null &&
                    graphData?.productTimeWiseScanList?.length > 0 ? (
                    <NVD3Chart
                      type="stackedAreaChart"
                      //datum={areaChartData}
                      datum={graphData?.productTimeWiseScanList}
                      height={300}
                      options={areaChartOptions}
                    />
                  ) : (
                    <>
                      {" "}
                      <h4 className="mb-0 text-grey">No Data Found</h4>
                    </>
                  )}

                  {graphData?.productTimeWiseScanList?.length > 0 && (
                    <button
                      onClick={(e) => {
                        GetProductTimeWiseScanningAnalyticReport();
                      }}
                      type="button"
                      className="btn btn-primary btn-xs ml-3"
                    >
                      Details
                    </button>
                  )}
                </div>
              </div>
            </PanelBody>
          </Panel>
        </div>

        <ProductionTimeWiseAnalysis isOpen={IstimewisemodalOpen} toggleLableTableclosed={() => { ToggleTimewisemodalOpen() }} articleTimeWiseScanListDetalis={articleTimeWiseScanListDetalis}></ProductionTimeWiseAnalysis>

        <div className="col-xl-4 col-lg-6 countrywisecss pb-4">
          <Panel className="penal-stretch">
            <PanelHeader className="bg-dark-blue">
              <h4 className="mb-0 text-grey">Country wise scans</h4>
            </PanelHeader>
            <PanelBody className="bg-dark-blue">
              <div>
                <div className="widget-list widget-list-rounded inverse-mode ">
                  <div className="widget-list-item">
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1 text-left">
                      Country
                    </h4>
                    <h4 className="widget-list-action text-nowrap text-white pb-1 pt-1">
                      Scans
                    </h4>
                  </div>
                  <div className=" table-responsive">
                    {DatatablecountryWiseScanLits?.slice(0, 5).map(
                      (countryWiseitem, i) => {
                        let CountryId = countryList.find(
                          (x) => x.name === countryWiseitem.name
                        );
                        console.log(
                          "CountryId===>",
                          CountryId?.code?.toLowerCase()
                        );
                        return (
                          <>
                            <div className="widget-list-item ok">
                              <div className="widget-list-media icon">
                                <div
                                  className="widget-img widget-img-xs rounded bg-inverse mr-2 width-40"
                                  style={{
                                    backgroundImage: `url(https://flagpedia.net/data/flags/normal/${CountryId?.code?.toLowerCase()}.png)`,
                                  }}
                                ></div>
                              </div>
                              <div className="widget-list-content  pb-1 pt-1 border-none">
                                <p className=" table-subtext">
                                  {countryWiseitem?.name}
                                </p>
                              </div>

                              <div className="widget-list-action text-nowrap  pb-1 pt-1">
                                <p className="table-scan-subtext">
                                  {countryWiseitem?.totalScanCount}
                                </p>
                                <button
                                  onClick={(e) => {
                                    toggleCountry(countryWiseitem);
                                  }}
                                  type="button"
                                  className="btn btn-primary btn-xs ml-3"
                                >
                                  Details
                                </button>
                              </div>
                            </div>
                          </>
                        );
                      }
                    )}
                  </div>
                  <div className="text-center p-5">
                    {DatatablecountryWiseScanLits.length > 0 && (
                      <button
                        type="button"
                        className="btn btn-purple m-5"
                        onClick={(e) => {
                          setbestscancountryishow(true);
                        }}
                      >
                        See All
                      </button>
                    )}
                  </div>
                  <ProductionCountrywisescans
                    isOpen={bestscancountryishow}
                    togglecountryTableclosed={() => {
                      togglecountryTableclosed()
                    }}
                    DatatablecountryWiseScanLits={DatatablecountryWiseScanLits}
                    toggleCountry={(item) => {
                      toggleCountry(item);
                    }}
                  ></ProductionCountrywisescans>

                  <Modal
                    isOpen={modalCountry}
                    toggle={toggleCountry}
                    className="modal-size"
                  >
                    <ModalHeader
                      toggle={toggleCountry}
                      className="modalheader "
                    >
                      <div className="d-flex align-items-center">
                        <h4 className="text-white mb-0">
                          Locations country wise scans
                        </h4>

                        <button
                          className="btn btn-primary btm-sm ml-2"
                          onClick={(e) => handleActioncountry("DOWNLOAD")}
                        >
                          Download data
                        </button>
                        <CSVLink
                          headers={countrycsvheaders}
                          data={countrycsvdata}
                          filename={
                            "Country_" +
                            Moment(new Date()).format("DD-MM-Y HH:mm:ss") +
                            ".csv"
                          }
                          className="hidden"
                          ref={countrycsvRef}
                          target="_blank"
                        />
                      </div>
                    </ModalHeader>
                    <ModalBody>
                      <div className="sparkline8-list shadow-reset">
                        <div className="sparkline8-graph table-responsive">
                          <table
                            id="data-table-buttons"
                            className="table table-striped table-bordered table-td-valign-middle text-center"
                          >
                            <thead>
                              <tr className="odd gradeA">
                                <th className="text-nowrap">Sr #</th>
                                <th className="text-nowrap">Country</th>
                                <th className="text-nowrap">City</th>
                                <th className="text-nowrap">Scans</th>
                                <th className="text-nowrap">Details</th>
                              </tr>
                            </thead>
                            <tbody>
                              {Locationswisecanning.length > 0 &&
                                Locationswisecanning.map((item, i) => (
                                  <tr>
                                    <td>{i + 1}</td>
                                    <td>{item.countryName}</td>
                                    <td>
                                      {item.cityName ? item.cityName : ""}
                                    </td>
                                    <td>{item.totalScanCount}</td>
                                    <td>
                                      <button
                                        onClick={(e) => {
                                          // toggleCity(item);
                                          getcitywisescanningDetail(item);
                                        }}
                                        type="button"
                                        className="btn btn-primary btn-xs ml-3"
                                      >
                                        Details
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div className="text-center">
                      
                      </div>
                    </ModalBody>
                  </Modal>
                  <Modal
                    isOpen={modalCity}
                    toggle={toggleCity}
                    className="modal-size"
                  >
                    <ModalHeader toggle={toggleCity} className="modalheader ">
                      <div className="d-flex align-items-center">
                        <h4 className="text-white mb-0">
                          Locations city wise scans
                        </h4>

                        <button
                          className="btn btn-primary btm-sm ml-2"
                          onClick={(e) => handleActionCity("DOWNLOAD")}
                        >
                          Download data
                        </button>
                        <CSVLink
                          headers={Citycsvheaders}
                          data={Citycsvdata}
                          filename={
                            "City_" +
                            Moment(new Date()).format("DD-MM-Y HH:mm:ss") +
                            ".csv"
                          }
                          className="hidden"
                          ref={CitycsvRef}
                          target="_blank"
                        />
                      </div>
                    </ModalHeader>
                    <ModalBody>
                      <div className="sparkline8-list shadow-reset">
                        <div className="sparkline8-graph table-responsive">
                          {LocationsCitywisecanning.length !== null ? (
                            <div>
                              <div className="sparkline8-list shadow-reset">
                                <div className="sparkline8-graph table-responsive">
                                  {bestsCityallshow === true ? (
                                    <ProductionLocationscitywisescans LocationsCitywisecanning={LocationsCitywisecanning}></ProductionLocationscitywisescans>
                                  ) : (
                                    <table
                                      id="data-table-buttons"
                                      className="table table-striped table-bordered table-td-valign-middle text-center"
                                    >
                                      <thead>
                                        <tr className="odd gradeA">
                                          <th className="text-nowrap">Sr #</th>
                                          <th className="text-nowrap">
                                            Country
                                          </th>
                                          <th className="text-nowrap">City</th>
                                          <th className="text-nowrap">
                                            QR Code Name
                                          </th>
                                          {/* <th className="text-nowrap">Type</th> */}
                                          <th className="text-nowrap">Pic</th>
                                          <th className="text-nowrap">Scans</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {LocationsCitywisecanning.length > 0 &&
                                          LocationsCitywisecanning.slice(
                                            0,
                                            5
                                          ).map((item, i) => (
                                            <tr>
                                              <td>{i + 1}</td>
                                              <td>{item.countryName}</td>
                                              <td>
                                                {" "}
                                                {item.cityName
                                                  ? item.cityName
                                                  : ""}
                                              </td>
                                              <td>
                                                {item.productName
                                                  ? item.productName
                                                  : ""}
                                              </td>
                                              {/* <td>{item. qrcodeType ? item. qrcodeType : "N/A"}</td> */}

                                              <td>
                                                <div>
                                                  <img
                                                    src={
                                                      Config?.contentUrl +
                                                      item?.productImagepath
                                                    }
                                                    style={{ height: "50px" }}
                                                    onError={({
                                                      currentTarget,
                                                    }) => {
                                                      currentTarget.onerror =
                                                        null; // prevents looping
                                                      currentTarget.src =
                                                        "../assets/img/mtsttqr.png";
                                                    }}
                                                  ></img>
                                                </div>
                                              </td>
                                              <td>{item.totalScanCount}</td>
                                            </tr>
                                          ))}
                                      </tbody>
                                    </table>
                                  )}
                                </div>
                              </div>
                              <div className="text-center">
                                {bestsCityallshow === true ? (
                                  <button
                                    type="button"
                                    className="btn btn-purple m-5"
                                    onClick={(e) => {
                                      setbestsCityallshow(false);
                                    }}
                                  >
                                    Hide
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    className="btn btn-purple m-5"
                                    onClick={(e) => {
                                      setbestsCityallshow(true);
                                    }}
                                  >
                                    See All
                                  </button>
                                )}
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </ModalBody>
                  </Modal>
                </div>
              </div>
            </PanelBody>
          </Panel>
        </div>
      </div>

      <div className="row change-header-bg">
        <div className="col-xl-6 pb-4">
          <Panel className="penal-stretch">
            <PanelHeader className="bg-dark-blue">
              <h4 className="mb-0 text-grey">Operating system wise scanning</h4>
            </PanelHeader>
            <PanelBody className="bg-dark-blue">
              <div style={{ height: "325px" }}>
                {/* <Pie data={pieChart.data} options={pieChart.options} /> */}
                {graphData !== null && graphData?.pipeBarchat !== null ? (
                  <Pie
                    data={graphData?.pipeBarchat}
                    options={pieChart.options}
                  />
                ) : (
                  <>
                    <h4 className="mb-0 text-grey">No Data Found</h4>
                  </>
                )}
              </div>
            </PanelBody>
          </Panel>
        </div>
        <div className="col-xl-6 pb-4">
          <Panel className="penal-stretch">
            <PanelHeader className="bg-dark-blue">
              <h4 className="mb-0 text-grey">Product performing vendors</h4>
            </PanelHeader>
            <PanelBody className="bg-dark-blue">
              <div className="table-responsive">
                <div className="table-responsive">
                  <table
                    className="table table-bordered m-b-0"
                    style={{ color: "#FFFFFF" }}
                  >
                    <thead style={{ backgroundColor: "#959595" }}>
                      <tr className="text-center">
                        <th>Sr #</th>
                        <th>Vendors</th>
                        <th>Logo</th>
                        <th>Total Scans</th>
                      </tr>
                    </thead>
                    <tbody>
                      {DatatableVendorWiseList?.length > 0 ? (
                        DatatableVendorWiseList.slice(0, 3).map((item, i) => (
                          <tr className="text-center">
                            <td className="align-middle">{i + 1}</td>
                            <td className="align-middle">
                              {item?.vendorName ? item?.vendorName : ""}
                            </td>
                            <td>
                              <div>
                                <img
                                  // src="../assets/img/user/user-7.jpg"
                                  src={Config?.contentUrl + item?.logoPath}
                                  style={{ height: "50px" }}
                                  onError={({ currentTarget }) => {
                                    currentTarget.onerror = null; // prevents looping
                                    currentTarget.src =
                                      "../assets/img/noimage.jpg";
                                  }}
                                ></img>
                              </div>
                            </td>
                            <td className="align-middle">
                              {item?.totalVendorScanCount}
                              <button
                                type="button"
                                className="btn btn-primary btn-xs ml-3"
                                onClick={(e) => {
                                  getVendorwisescanningDetail(item);
                                }}
                              >
                                Details
                              </button>
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr className="text-center">
                          <label>No Data Found</label>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  <div className="text-center my-3">
                    {DatatableVendorWiseList?.length > 0 && (
                      <button
                        type="button"
                        className="btn btn-purple m-5"
                        onClick={(e) => {
                          toggleVendorsshowall();
                        }}
                      >
                        See All
                      </button>
                    )}
                  </div>
                  <Bestperformingvendors  
                  isOpen={bestScanVendorisall} 
                  toggleVendorsshowall ={()=>{toggleVendorsshowall()}}
                  DatatableVendorWiseList={DatatableVendorWiseList}
                  getVendorwisescanningDetail={(item)=>{getVendorwisescanningDetail(item)}}
                  ></Bestperformingvendors>

                  <Modal
                    isOpen={modalVendors}
                    toggle={toggleVendors}
                    className="modal-size"
                  >
                    <ModalHeader
                      toggle={toggleVendors}
                      className="modalheader "
                    >
                      <div className="d-flex align-items-center">
                        <h4 className="text-white mb-0">
                          Best performing Vendor detail
                        </h4>

                        <button
                          className="btn btn-primary btm-sm ml-2"
                          onClick={(e) => handleActionVendor("DOWNLOAD")}
                        >
                          Download data
                        </button>
                        <CSVLink
                          headers={Vendorheaders}
                          data={Vendorcsvdata}
                          filename={
                            "Vendor_" +
                            Moment(new Date()).format("DD-MM-Y HH:mm:ss") +
                            ".csv"
                          }
                          className="hidden"
                          ref={VendorcsvRef}
                          target="_blank"
                        />
                      </div>
                    </ModalHeader>
                    <ModalBody>
                      <div className="sparkline8-list shadow-reset">
                        <div className="sparkline8-graph table-responsive">
                          {VendorDetailsAllshow === true ? (
                            <ProductionBestperformingVendordetail DatatableVendordetailsWiseList={DatatableVendordetailsWiseList}></ProductionBestperformingVendordetail>
                           ) : (
                            <table
                              id="data-table-buttons"
                              className="table table-striped table-bordered table-td-valign-middle text-center"
                            >
                              <thead>
                                <tr className="odd gradeA">
                                  <th className="text-nowrap">Sr #</th>
                                  <th className="text-nowrap">Vendor Name</th>
                                  <th className="text-nowrap">Logo</th>
                                  <th className="text-nowrap">QR Code Name</th>
                                  <th className="text-nowrap">Pic</th>
                                  <th className="text-nowrap">Total Scans</th>
                                </tr>
                              </thead>
                              <tbody>
                                {DatatableVendordetailsWiseList.length > 0 &&
                                  DatatableVendordetailsWiseList.slice(
                                    0,
                                    3
                                  ).map((item, i) => (
                                    <tr>
                                      <td>{i + 1}</td>
                                      <td>{item.vendorName}</td>
                                      <td>
                                        <div>
                                          <img
                                            src={
                                              Config?.contentUrl +
                                              item?.vendorLogo
                                            }
                                            style={{ height: "50px" }}
                                            onError={({ currentTarget }) => {
                                              currentTarget.onerror = null; // prevents looping
                                              currentTarget.src =
                                                "../assets/img/noimage.jpg";
                                            }}
                                          ></img>
                                        </div>
                                      </td>
                                      <td>
                                        {item.productName
                                          ? item.productName
                                          : ""}
                                      </td>

                                      <td>
                                        <div>
                                          <img
                                            src={
                                              Config?.contentUrl +
                                              item?.productImagepath
                                            }
                                            style={{ height: "50px" }}
                                            onError={({ currentTarget }) => {
                                              currentTarget.onerror = null; // prevents looping
                                              currentTarget.src =
                                                "../assets/img/noimage.jpg";
                                            }}
                                          ></img>
                                        </div>
                                      </td>
                                      <td>{item.totalScanCount}</td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          )}
                        </div>
                      </div>
                      {DatatableVendordetailsWiseList?.length > 0 && (
                        <div className="text-center">
                          {VendorDetailsAllshow === true ? (
                            <button
                              type="button"
                              className="btn btn-purple m-5"
                              onClick={(e) => {
                                setVendorDetailsAllshow(false);
                              }}
                            >
                              Hide
                            </button>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-purple m-5"
                              onClick={(e) => {
                                setVendorDetailsAllshow(true);
                              }}
                            >
                              See All
                            </button>
                          )}
                        </div>
                      )}
                    </ModalBody>
                  </Modal>
                </div>
              </div>
            </PanelBody>
          </Panel>
        </div>
      </div>
    </div>
  );
};
export default Productreports;
